export const normalize = (value) => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
export const today = () => new Date().toLocaleDateString('en-CA', { timeZone: 'America/Mexico_City' });
export const absent = (value) => value === null || value === undefined || value === '';
export const money = (value) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'USD' }).format(value);

export function monday(value) {
  const date = new Date(`${value}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() - ((date.getUTCDay() + 6) % 7));
  return date.toISOString().slice(0, 10);
}

export function formPayload(fields, form) {
  return Object.fromEntries(fields.map((field) => {
    const value = form[field.key];
    if (absent(value)) return [field.key, null];
    return [field.key, ['integer', 'money', 'percent'].includes(field.type)
      ? Number(value) / (field.type === 'percent' ? 100 : 1) : String(value).trim() || null];
  }));
}

export function buildReport(content = {}) {
  const rows = (kind) => (content[kind] || []).filter((row) => row.activo !== false);
  const projects = rows('proyectos_sp'), services = rows('servicios_admin'), opportunities = rows('pipeline');
  const rank = { verde: 0, amarillo: 1, rojo: 2 };
  const statuses = (states) => Object.fromEntries(['verde', 'amarillo', 'rojo', 'sin dato'].map((state) => [
    state, states.filter((value) => state === 'sin dato' ? rank[value] === undefined : value === state).length,
  ]));
  const clients = new Map();
  services.forEach((row) => {
    const key = normalize(row.cliente), status = normalize(row.semaforo), current = clients.get(key);
    if (!clients.has(key) || rank[status] === undefined || (rank[current] !== undefined && rank[status] > rank[current])) {
      clients.set(key, status);
    }
  });
  const pipeline = opportunities.filter((row) => !['ganada', 'perdida'].includes(normalize(row.etapa)));
  const issues = rows('highlights_riesgos').filter((row) => normalize(row.mostrar_direccion) === 'si' && normalize(row.estatus) !== 'cerrado');
  const sum = (data, key) => data.reduce((total, row) => total + (absent(row[key]) ? 0 : Number(row[key])), 0);
  const groups = new Map();
  pipeline.forEach((row) => {
    const key = row.practica || 'Sin dato';
    groups.set(key, (groups.get(key) || 0) + (absent(row.monto_mensual) ? 0 : Number(row.monto_mensual)));
  });
  const weeks = new Map();
  [...projects, ...services, ...opportunities, ...rows('highlights_riesgos')].forEach((row) => {
    if (row.fecha) {
      const week = monday(row.fecha);
      weeks.set(week, (weeks.get(week) || 0) + 1);
    }
  });
  return {
    projects, services, pipeline, issues,
    clientCount: clients.size, adminStatuses: statuses([...clients.values()]),
    projectStatuses: statuses(projects.map((row) => normalize(row.semaforo))),
    pipelineAmount: sum(pipeline, 'monto_mensual'),
    pipelineMissing: pipeline.filter((row) => absent(row.monto_mensual)).length,
    pipelineGroups: [...groups].map(([name, amount]) => ({ name, amount })),
    budget: sum(projects, 'total_presupuestado'),
    budgetMissing: projects.filter((row) => absent(row.total_presupuestado)).length,
    escalations: projects.filter((row) => normalize(row.requiere_escalamiento) === 'si').length,
    sla: sum(services, 'tickets_fuera_sla'), incidents: sum(services, 'incidentes_mayores'),
    slaMissing: services.filter((row) => absent(row.tickets_fuera_sla) || absent(row.incidentes_mayores)).length,
    ticket: rows('tickets_mes')[0] || null,
    weeks: [...weeks].sort(([a], [b]) => a.localeCompare(b)),
  };
}
